<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>门店管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
            <el-upload class="upload-demo"
                       style="width:130px;display: inline-block;"
                       ref="upload"
                       action=""
                       :auto-upload="false"
                       :on-change="query => onUploadFile(query,1)"
                       accept=".xlsx,.xls"
                       :show-file-list="false">
              <el-button icon="sj-icon-add"
                         type="primary"
                         size="mini">批量添加门店
              </el-button>
            </el-upload>
            <el-upload class="upload-demo"
                       style="width:130px;display: inline-block;"
                       ref="upload"
                       action=""
                       :auto-upload="false"
                       :on-change="query => onUploadFile(query,2)"
                       accept=".xlsx,.xls"
                       :show-file-list="false">
              <el-button icon="sj-icon-add"
                         type="primary"
                         size="mini">批量更新门店
              </el-button>
            </el-upload>
            <el-upload class="upload-demo"
                       style="width:170px;display: inline-block;"
                       ref="upload"
                       action=""
                       :auto-upload="false"
                       :on-change="query => onUploadFile(query,3)"
                       accept=".xlsx,.xls"
                       :show-file-list="false">
              <el-button icon="sj-icon-add"
                         type="primary"
                         size="mini">批量更新门店(不覆盖)
              </el-button>
            </el-upload>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="50"></el-table-column>
        <el-table-column prop="display_name"
                         label="名称"
                         min-width="120">
          <template slot-scope="scope">
            <span style="cursor:pointer;color:rgb(88,157,248)"
                  @click="onDownSourceFile(scope.row.id)">{{scope.row.display_name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="admin_name"
                         label="发起者"
                         min-width="120"></el-table-column>
        <el-table-column prop="created_at"
                         label="上传时间"
                         min-width="120"></el-table-column>
        <el-table-column label="任务进度"
                         min-width="120">
          <template slot-scope="scope">
            <sj-progress :text-inside="true"
                         :stroke-width="18"
                         :status="taskBatchStatus(scope.row)"
                         :percentages="taskBatchPercentage(scope.row)"></sj-progress>
            成功:{{scope.row.success_count}} 错误:{{scope.row.error_count}}
            　<span v-if="scope.row.task_type === 211">冲突: {{scope.row.unprocess_count}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="task_type"
                         label="类型"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in options.task_type"
                  v-if="scope.row.task_type === item.value">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         label="状态"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in status"
                  v-if="scope.row.status === item.value">{{item.label}}</span>
            <span v-if="scope.row.status === -2 && scope.row.error_message">{{scope.row.error_message}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="260">
          <template slot-scope="scope">
            <span v-if="[3, -1, -2].includes(scope.row.status) && scope.row.unprocess_count > 0">
                <el-button type="text"
                           size="mini"
                           @click="onUnprocessFile(scope.row.id)">下载冲突项</el-button>
            </span>
            <span v-if="[3, -1, -2].includes(scope.row.status) && scope.row.error_count > 0">
              <el-button type="text"
                         size="mini"
                         @click="onDownErrorFile(scope.row.id)">下载错误行</el-button>
            </span>
            <span v-if="[3, -1].includes(scope.row.status) && scope.row.task_type === 269 && scope.row.success_count > 0">
              <el-button type="text"
                         size="mini"
                         @click="onDownSourceFile(scope.row.id)">下载处理结果
              </el-button>
            </span>
            <span v-if="[3, -1].includes(scope.row.status) && scope.row.task_type === 209 && scope.row.success_count > 0">
              <el-button type="text"
                         size="mini"
                         @click="onDownExportFile(scope.row.id)">下载处理结果</el-button>
            </span>
            <span v-if="checkAllowCancel(scope.row)">
              <el-button type="text"
                         size="mini"
                         v-if="['', parseInt(users.id)].includes(scope.row.admin_id)"
                         @click="onCancelTaskBatch(scope.row.id)">取消</el-button>
            </span>

            <span v-if="checkAllowPause(scope.row)">
              <el-button type="text"
                         size="mini"
                         v-if="['', parseInt(users.id)].includes(scope.row.admin_id)"
                         @click="onPauseTaskBatch(scope.row.id)">暂停</el-button>
            </span>

            <span v-if="checkAllowContinue(scope.row)">
              <el-button type="text"
                         size="mini"
                         v-if="['', parseInt(users.id)].includes(scope.row.admin_id)"
                         @click="onContinueTaskBatch(scope.row.id)">继续</el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import downloadJS from 'downloadjs'
import SjProgress from '@/components/sj-progress'
import taskBatchMixins from '@/views/task-batch/task-batch.mixins'
import { taskTypes } from '@/views/task-batch/task-batch-opts'

export default {
  mixins: [table, taskBatchMixins],
  components: {SjProgress},
  data () {
    return {
      options: {
        task_type: [
          {value: 209, label: '批量添加门店'},
          {value: 210, label: '批量更新门店'},
          {value: 211, label: '批量更新门店(不覆盖)'},
          {value: 246, label: '批量更新城市单价'},
          {value: 259, label: '批量导出门店'},
          {value: 261, label: '导出省市区关系'},
          { ...taskTypes.BATCH_UPDATE_TASK_AFTER_MARKET_MODIFIED },
        ],
      },
      search: {
        // collection_type: 3,
        number: this.$route.params.number || '',
        task_type: []
      },
    }
  },
  computed: Vuex.mapState({
    status: state => state.taskBatch.status,
    users: state => state.login.user,
  }),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      if (!_.get(params, 'task_type', '')) {
        params.task_type = this.options.task_type.map(it => it.value)
      }
      return request.common('queryBatchUpload', params)
    },
    onDownSourceFile (id) {
      downloadJS(request.items.downSourceFile(id))
    },
    onDownErrorFile (id) {
      downloadJS(request.items.downErrorFile(id))
    },
    onUnprocessFile (id) {
      downloadJS(request.items.downUnprocessFile(id))
    },
    onDownExportFile (id) {
      downloadJS(request.items.downExportFile(id))
    },
    onUploadFile (file, type) {
      let isLt10M = file.raw.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        this.$refs.upload.clearFiles()
        return false
      }

      let formData = new FormData()
      formData.append('file', file.raw)
      if (type === 1) {
        this.batchUploadCreateMarket(formData)
      } else if (type === 2 || type === 3) {
        this.$confirm('提示：批量修改门店经纬度后，门店下【新创建 / 待抢单 / 已抢单】任务的经纬度将会同步批量更新，请确认是否继续操作', '批量修改门店', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          if (type === 2) {
            this.batchUploadUpdateAllRightMarket(formData)
          } else {
            this.batchUploadUpdateMarket(formData)
          }
        }).catch(() => {})
      } else {
        return false
      }
    },
    batchUploadCreateMarket (formData) {
      request.common('batchUploadCreateMarket', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
    batchUploadUpdateAllRightMarket (formData) {
      request.common('batchUploadUpdateAllRightMarket', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
    batchUploadUpdateMarket (formData) {
      request.common('batchUploadUpdateMarket', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
    onCancelTaskBatch (id) {
      request.common('cancelTaskBatch', {id: id}).then(({data}) => {
        this.$message('取消批量任务(' + id + ')请求成功')
        this.onSearch()
      })
    },
    onPauseTaskBatch (id) {
      request.common('pauseTaskBatch', {id}).then(() => {
        this.$message('暂停批量任务(' + id + ')已请求成功')
        this.onSearch()
      })
    },
    onContinueTaskBatch (id) {
      request.common('continueTaskBatch', {id}).then(() => {
        this.$message('继续批量任务(' + id + ')已请求成功')
        this.onSearch()
      })
    },
    checkAllowCancel (row) {
      return [1, 2].includes(row.status) && [209, 210, 211].includes(row.task_type)
    },
    checkAllowPause (row) {
      return row.status === 2 && [209, 210, 211].includes(row.task_type)
    },
    checkAllowContinue (row) {
      const now = moment()
      const before = moment(row.created_at)
      const notMoreThenThreeDays = moment(now).diff(before) < 3 * 86400000
      return row.status === -6 && notMoreThenThreeDays
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/market/pages/MarketUplaodTable.vue